export default __webpack_public_path__ + "static/media/640_dummy2016-allgemeinarzt01-de.f6d84a5c.png";